/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import React from 'react';
import * as d3 from 'd3';

export class KeyframeCreator extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.selection = React.createRef();
	}

	clearBrush() {
		// Removes the rect selection
		let selection = d3.select(this.selection.current);
		selection
			.transition()
			.duration(250)
			.style('opacity', 0.0)
			.on(
				'end',
				function () {
					selection.call(this.state.brush.move, null);
					selection.style('opacity', null);
				}.bind(this)
			);
	}

	componentDidMount() {
		// So that the brush is also created on mount.
		this.componentDidUpdate();
	}

	componentDidUpdate() {
		const { chartContext } = this.props;
		const { margin, dataHeight, dataWidth } = chartContext;
		const selectionExtents = [
			[margin.left, margin.top],
			[dataWidth + margin.left, dataHeight + margin.top],
		];
		let brushToUse = this.state.brush;

		if (brushToUse == null) {
			// TOOD: Allow the timeline to be accessed normally from the bottom portion
			// https://github.com/d3/d3-drag#drag_container might help.
			let aNewBrush = d3.brushX().on('end', this.onBrush);

			this.setState({ brush: aNewBrush });
			brushToUse = aNewBrush;
		}

		d3.select(this.selection.current).call(brushToUse.extent(selectionExtents));
	}

	onBrush = (event) => {
		const { chartContext, newKeyframe } = this.props;
		const { xScale } = chartContext;
		const extent = event.selection;

		if (extent) {
			const keyframeInterval = extent.map(xScale.invert);
			newKeyframe(keyframeInterval);
			this.clearBrush();
		}
	};

	render() {
		return (
			<g
				cy-test="timeline"
				className="dragger"
				ref={this.selection}
			>
				<rect
					css={css`
						fill: rgba(0, 0, 0, 0.3);
						stroke-dasharray: 5, 5;
						transition: opacity 0.5s linear;
					`}
				/>
			</g>
		);
	}
}
